import { Trans, useLingui } from "@lingui/react/macro";

import { FORM_NAME, useUpdateMyInfo } from "~/hook/overlay/useUpdateMyInfo.ts";
import { ModalNavigation } from "~/ui/base/Navigation.tsx";
import { createStackedPage } from "~/ui/base/StackedPage.tsx";

export const UpdateMyInfoStack = createStackedPage(({ close, titleId }) => {
  const { t } = useLingui();
  const {
    data,
    formRef,
    handleImageChange,
    handleNameChange,
    handleSubmit,
    isMutating,
  } = useUpdateMyInfo(close);

  return (
    <div>
      <ModalNavigation
        left={{
          disabled: isMutating,
          label: t`취소`,
          onClick: close,
        }}
        right={{
          disabled: isMutating,
          label: t`완료`,
          onClick: handleSubmit,
        }}
        title={t`프로필 편집`}
        titleId={titleId}
      />
      <div className="h-[calc(4rem+var(--safe-top))]"></div>
      <form
        className="h-full overflow-y-scroll p-5"
        onSubmit={(e) => {
          e.preventDefault();
        }}
        ref={formRef}
      >
        <div className="flex justify-center">
          <label className="flex cursor-pointer flex-col items-center gap-2">
            <img
              alt={t`프로필 이미지`}
              className="h-20 w-20 rounded-full bg-zinc-200 object-cover dark:bg-zinc-800"
              src={data.profileImageUrl ?? "/asset/default_user_profile.png"}
            />
            <p className="text-sm font-medium text-zinc-800 dark:text-zinc-200">
              <Trans>사진 수정</Trans>
            </p>
            <input
              accept="image/png,image/jpg,image/jpeg"
              className="hidden"
              id="profileImage"
              name={FORM_NAME.PROFILE_IMAGE}
              onChange={(e) => {
                handleImageChange(e.target.files?.item(0) ?? undefined);
              }}
              type="file"
            />
          </label>
        </div>
        <div
          className="grid items-center gap-3 pt-8 text-sm"
          style={{ gridTemplateColumns: "80px 1fr" }}
        >
          <label htmlFor="name">
            <Trans>이름</Trans>
          </label>
          <input
            className="rounded-none border-b border-zinc-200 bg-transparent p-2 text-zinc-800 outline-hidden focus:border-black dark:border-zinc-800 dark:text-zinc-100 dark:focus:border-white"
            id="name"
            onChange={({ target: { value: name } }) => {
              handleNameChange(name);
            }}
            type="text"
            value={data.name}
          />
        </div>
      </form>
    </div>
  );
});
